import {
  AddNewWordDialog,
  SentencesExampleDialog,
} from "../../DictionaryTools/components/DictionaryToolsResultPanel/components/SavedWords/SaveWords";
import ExerciseListSidePanel from "./../sidePanel/ExerciseListSidePanel/ExerciseListSidePanel";
import PageWithLeftSidebar from "../PageContentWithLeftSidebar/PageContentWithLeftSidebar";
import StudentListSidePanel from "./../sidePanel/StudentListSidePanel/StudentListSidePanel";
import DictionaryTools, { DictionaryMode } from "./../../DictionaryTools/DictionaryTools";
import HomeworkSidePanel from "./../sidePanel/HomeworkSidePanel/HomeworkSidePanel";
import PageWithHeaderFooter from "./../PageWithHeaderFooter/PageWithHeaderFooter";
import SelectionBehaviour from "./../../SelectionBehaviour/SelectionBehaviour";
import { isUserStudent, isUserTeacher } from "../../../services/authUtil";
import TalaeraRoutes from "./../../routes/TalaeraRoutes";
import PageHeader from "./../PageHeader";
import React, { Component } from "react";
import Sidebar from "react-sidebar";
import "./PageLayout.css";
import { ExerciseDialog } from "../../DictionaryTools/components/DictionaryToolsResultPanel/components/ExerciseDialog/ExerciseDialog";
import { ErrorBoundary } from "components/ErrorBoundary";
import { getErrorComponents } from "../../../services/util";
import AppDialogWithHeader from "../../AppDialog/AppDialogWithHeader";

const MIN_SIDEBAR_WIDTH = 300;
const DEFAULT_SIDEBAR_WIDTH = 450;

export default class PageLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSidebarOpened: false,
      selectedText: "",
      selectedMode: null,
      isSidebarSelectionOpened: false,
      isPageSelectionOpened: false,
      openAddDialog: false,
      openExampleDialog: false,
      openPracticeVocabDialog: false,
      exampleWord: "",
      isDragging: false,
      sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
      vocabCount: 0,
    };

    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.closeSidebar = this.closeSidebar.bind(this);
    this.openPrefilledSidebar = this.openPrefilledSidebar.bind(this);
    this.updateState = this.updateState.bind(this);
    this.onOpenAddWordDialog = this.onOpenAddWordDialog.bind(this);
    this.onOpenExampleDialog = this.onOpenExampleDialog.bind(this);
    this.onCloseExampleDialog = this.onCloseExampleDialog.bind(this);
    this.onOpenPracticeVocabDialog = this.onOpenPracticeVocabDialog.bind(this);
    this.onClosePracticeVocabDialog = this.onClosePracticeVocabDialog.bind(this);
    this.onDragSidebar = this.onDragSidebar.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // Page is changed, clear selection behaviour.
      this.selectionBehaviour && this.selectionBehaviour.clearState();
    }
  }

  toggleSidebar() {
    this.setState({
      isSidebarOpened: !this.state.isSidebarOpened,
    });
  }

  closeSidebar() {
    this.setState({ isSidebarOpened: false });
  }

  openPrefilledSidebar(selection, mode) {
    if (!selection) {
      return;
    }
    this.setState({
      selectedText: selection,
      selectedMode: mode,
      isSidebarOpened: true,
    });
    if (this.tools) {
      if (mode === DictionaryMode.TRANSLATE) {
        this.tools.onTranslate(selection);
      } else if (mode === DictionaryMode.DEFINE) {
        this.tools.onSearch(selection, DictionaryMode.DEFINE);
      } else {
        this.tools.onSaveWord(selection);
      }
    }
  }

  updateState = type => isContextMenuOpened => {
    if (type === "sidebar") {
      this.setState({
        isSidebarSelectionOpened: isContextMenuOpened,
        isPageSelectionOpened: !isContextMenuOpened,
      });
    } else {
      this.setState({
        isPageSelectionOpened: isContextMenuOpened,
        isSidebarSelectionOpened: !isContextMenuOpened,
      });
    }
  };

  refreshHeader = () => {
    this.pageHeader && this.pageHeader.refresh();
  };

  onCloseAddWordDialog = refresh => {
    if (refresh === true) {
      this.tools && this.tools.onRefresh();
    }
    this.setState({ openAddDialog: false });
  };

  onOpenAddWordDialog() {
    this.setState({ openAddDialog: true });
  }

  onCloseExampleDialog() {
    this.setState({ openExampleDialog: false });
  }

  onOpenExampleDialog(word) {
    this.setState({ openExampleDialog: true, exampleWord: word });
  }

  onOpenPracticeVocabDialog(totalCount) {
    this.setState({ openPracticeVocabDialog: true, vocabCount: totalCount });
  }

  onClosePracticeVocabDialog() {
    this.setState({ openPracticeVocabDialog: false });
  }

  onDragSidebar(event) {
    if (event.clientX !== 0) {
      const width = window.innerWidth - event.clientX;
      if (width >= MIN_SIDEBAR_WIDTH) {
        this.setState({
          sidebarWidth: width,
        });
      }
    }
  }

  render() {
    const shouldHaveLanguageTools = TalaeraRoutes.isPageWithLanguageTool(
      this.props.location.pathname,
      isUserTeacher() || isUserStudent()
    );

    const routes = React.cloneElement(this.props.routes, {
      openSidebar: this.openPrefilledSidebar,
      closeSidebar: this.closeSidebar,
      refreshHeader: this.refreshHeader,
    });
    const isStudentsOrStudentDetailsPage =
      TalaeraRoutes.isStudentDetailsPage(this.props.location.pathname) ||
      TalaeraRoutes.isStudentsPage(this.props.location.pathname);
    const showExerciseListSidePanel =
      (TalaeraRoutes.isExerciseListPage(this.props.location.pathname) ||
        TalaeraRoutes.isMyExerciseListPath(this.props.location)) &&
      isUserTeacher();
    const showHomeworkSidePanel =
      TalaeraRoutes.isHomeworkPage(this.props.location.pathname) && isUserStudent();
    let sidePanel = null;
    if (isStudentsOrStudentDetailsPage) {
      sidePanel = <StudentListSidePanel location={this.props.location} />;
    } else if (showExerciseListSidePanel) {
      sidePanel = <ExerciseListSidePanel location={this.props.location} />;
    } else if (showHomeworkSidePanel) {
      sidePanel = <HomeworkSidePanel location={this.props.location} />;
    }

    const content = (
      <PageWithHeaderFooter
        className={this.state.isSidebarOpened ? "sidebar-opened" : ""}
        header={
          <div className="page-header-container">
            {this.props.header}
            {!this.props.noHeader &&
              TalaeraRoutes.isPageWithHeader(this.props.location.pathname) && (
                <ErrorBoundary fallback={getErrorComponents("Something went wrong.")}>
                  <PageHeader
                    smallWindow={this.props.smallWindow}
                    toggleSidebar={this.toggleSidebar}
                  />
                </ErrorBoundary>
              )}
          </div>
        }
        footer={this.props.footer}
      >
        <div className="page-content">
          {isStudentsOrStudentDetailsPage ||
          showExerciseListSidePanel ||
          showHomeworkSidePanel ? (
            // eslint-disable-next-line
            /**
             * For StudentDetails page we have a side panel with a list of students. To prevent
             * reloading of that list, we need to specify the panel component before <Switch> of
             * react-router (that is defined in <UserRoutes> or other <...Routes>). This way, the
             * part that is under <Switch> will be reloaded only, not touching the components around.
             * The same idea is for ExerciseList page with its different filter options.
             * The same idea is for Homework page with its different filter options.
             */
            <PageWithLeftSidebar leftSidebar={sidePanel} pageContent={routes} />
          ) : (
            routes
          )}
        </div>
        {shouldHaveLanguageTools && (
          <SelectionBehaviour
            isContextMenuOpened={this.state.isPageSelectionOpened}
            scrollableParentId="sidebar-content-id"
            positionalParentId="sidebar-content-id"
            openSidebar={this.openPrefilledSidebar}
            updateParentState={this.updateState("page")}
            ref={c => (this.selectionBehaviour = c)}
          />
        )}
      </PageWithHeaderFooter>
    );

    const layout = shouldHaveLanguageTools ? (
      <>
        <div className="page-content-with-sidebar">
          <Sidebar
            sidebar={
              <ErrorBoundary fallback={getErrorComponents("Something went wrong.")}>
                <div className="sidebar-wrapper">
                  <div draggable onDragEnd={this.onDragSidebar} className="splitter" />
                  <DictionaryTools
                    isSelectionOpened={this.state.isSidebarSelectionOpened}
                    searchValue={this.state.selectedText}
                    mode={this.state.selectedMode}
                    onClose={this.closeSidebar}
                    openPrefilledSidebar={this.openPrefilledSidebar}
                    updateParentState={this.updateState("sidebar")}
                    onOpenAddWordDialog={this.onOpenAddWordDialog}
                    onOpenExampleDialog={this.onOpenExampleDialog}
                    onOpenPracticeVocabDialog={this.onOpenPracticeVocabDialog}
                    ref={dt => (this.tools = dt)}
                  />
                </div>
              </ErrorBoundary>
            }
            docked={this.state.isSidebarOpened}
            styles={{
              sidebar: {
                maxWidth: `${this.state.sidebarWidth}px`,
                minWidth: `${this.state.sidebarWidth}px`,
                width: "25%",
                backgroundColor: "white",
              },
              content: { position: "fixed" },
            }}
            contentId="sidebar-content-id"
            sidebarId="sidebar-id"
            pullRight={true}
          >
            {content}
          </Sidebar>
        </div>

        <ErrorBoundary
          fallback={
            <AppDialogWithHeader
              showDialog
              closeOnOuterClick
              onClose={this.onCloseAddWordDialog}
              title={"Error"}
            >
              {getErrorComponents("Something went wrong.")}
            </AppDialogWithHeader>
          }
        >
          {this.state.openAddDialog && (
            <AddNewWordDialog
              open={this.state.openAddDialog}
              onListRefresh={this.tools.onRefresh}
              onClose={this.onCloseAddWordDialog}
            />
          )}

          {this.state.openExampleDialog && (
            <SentencesExampleDialog
              open={this.state.openExampleDialog}
              word={this.state.exampleWord}
              onClose={this.onCloseExampleDialog}
            />
          )}

          {this.state.openPracticeVocabDialog && (
            <ExerciseDialog
              smallVocab={this.state.vocabCount < 5}
              open={this.state.openPracticeVocabDialog}
              onClose={this.onClosePracticeVocabDialog}
            />
          )}
        </ErrorBoundary>
      </>
    ) : (
      content
    );

    return layout;
  }
}
